import './NextButton.css';
import React from 'react';

const NextButton = ({
    onClick = () => {},
    changeTurn = () => {},
    turn = '',
    socket = null,
    player = null,
    mode = '',
    setStreak = () => {}
}) => {
    return (
        <div className="next-button-container">
            <button
                className="btn-game btn-change"
                onClick={() => { onClick(socket); setStreak(0); }}
                disabled={turn !== player && player}
                title="Change board combination"
            >
                ↻ Change Teams
            </button>
            <button
                className="btn-game btn-skip"
                onClick={() => changeTurn(socket)}
                disabled={(turn !== player && player) || (mode === 'bot' && turn === 'O')}
                title="Skip your turn"
            >
                Skip Turn
            </button>
        </div>
    );
};

export default NextButton;
